import { FC, useEffect, useState } from "react";
import { Box, Flex, Heading, Text, VStack, Code } from "@chakra-ui/react";
import { usePageTitle } from "@Hooks/usePageTitle";
import { Button } from "@Components/Button";
import { keycloakService } from "@Services/keycloak";

const REASONS: Record<string, string> = {
  token_exchange_failed:
    "Falha ao trocar o código de acesso por token no SSO (redefrota-sso-api/api/oauth/token).",
  userinfo_failed:
    "Falha ao carregar seu usuário e permissões (gestaofrota-api/api/users/authorized).",
};

export const AuthorizationError: FC = () => {
  usePageTitle("Acesso negado");
  const [reason, setReason] = useState<string>("");
  const [detail, setDetail] = useState<string>("");

  useEffect(() => {
    const err = localStorage.getItem("authError") || "";
    setReason(REASONS[err] || (err ? `Erro: ${err}` : ""));
    setDetail(localStorage.getItem("authErrorDetail") || "");
  }, []);

  const handleSair = () => {
    localStorage.removeItem("authError");
    localStorage.removeItem("authErrorDetail");
    // Encerra a sessão no Keycloak, limpa tokens e volta ao login.
    keycloakService.logout();
  };

  return (
    <Flex minH="100vh" align="center" justify="center" p="24px">
      <Box
        bg="neutrals.surface.surface-0"
        borderRadius="16px"
        p="40px"
        maxW="480px"
        textAlign="center"
        border="1px solid"
        borderColor="neutrals.stroke.soft-200"
      >
        <VStack spacing={4}>
          <Heading
            as="h1"
            fontSize="22px"
            fontFamily="heading"
            color="states.error.base"
          >
            Falha na autenticação
          </Heading>
          <Text fontSize="sm" color="neutrals.text.sub-600" fontFamily="body">
            Não foi possível validar seu acesso. Tente novamente ou contate o
            administrador.
          </Text>

          {reason && (
            <Text
              fontSize="sm"
              color="neutrals.text.strong-950"
              fontFamily="body"
            >
              {reason}
            </Text>
          )}
          {detail && (
            <Code
              w="100%"
              p="10px"
              borderRadius="8px"
              fontSize="12px"
              whiteSpace="pre-wrap"
              textAlign="left"
              colorScheme="red"
            >
              {detail}
            </Code>
          )}

          <VStack spacing={2} w="100%" pt="4px">
            <Button
              colorSchema="brand"
              onClick={() => {
                window.location.href = "/login";
              }}
            >
              Tentar novamente
            </Button>
            <Button colorSchema="neutral" variant="outline" onClick={handleSair}>
              Sair
            </Button>
          </VStack>
        </VStack>
      </Box>
    </Flex>
  );
};
